import React from 'react';
import { Divider, Grid } from 'semantic-ui-react';
import ChangeEmail from '../Components/UserProfile/ChangeEmail';
import ChangePassword from '../Components/UserProfile/ChangePassword';

export const UserProfileDashboard: React.FunctionComponent = () => {
  return (
    <>
      <Grid stackable style={{ marginBottom: '2rem', flex: 1 }} columns={1}>
        <Grid.Row centered={true}>
          <Grid.Column>
            <Divider />
            <ChangeEmail />
            <Divider />
            <ChangePassword />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
};
